<div class="field-error" *ngFor="let error of errors">
    <ng-container *ngIf="control.invalid && control.errors[error.key] && hasRuleRaised(control, error)">
        {{ error.i18n|translate:error.params }}
    </ng-container>
</div>
